<template>
  <!-- 客服 -->
  <div class="custCare">
    <ul>
      <li>
        <el-popover placement="left" popper-class="pop_wx" trigger="hover">
          <div class="cus-service">
            <img src="@/assets/img/index/pic/cus-service.png" />
            <div class="addWx">扫码添加客服微信</div>
          </div>
          <div slot="reference">
            <!-- <img class="wx" src="@/assets/img/index/icon/right_navigation_1weixin.svg" /> -->
            <div class="wx"></div>
            <div class="line">添加微信</div>
          </div>
        </el-popover>
      </li>
      <li>
        <el-popover placement="left" popper-class="pop_tel" trigger="hover">
          <div class="tel_list">
            <div>售前咨询</div>
            <div>020-84661895</div>
            <div>15920366002</div>
            <div>服务时间：9:00-18:00</div>
          </div>
          <div slot="reference">
            <!-- <img class="tel" src="@/assets/img/index/icon/right_navigation_2telephone.svg" /> -->
            <div class="tel"></div>
            <div class="line">咨询热线</div>
          </div>
        </el-popover>
      </li>
<!--      <li @click="online">-->
<!--        <el-popover placement="left" popper-class="pop_online" trigger="hover">-->
<!--          <div class="tel_list">-->
<!--            <div>在线客服</div>-->
<!--            <div>亲，有什么可以帮助您？点我咨询</div>-->
<!--          </div>-->
<!--          <div slot="reference">-->
<!--            &lt;!&ndash; <img class="online" src="@/assets/img/index/icon/right_navigation_3service.svg" /> &ndash;&gt;-->
<!--            <div class="online"></div>-->
<!--            <div class="line">在线客服</div>-->
<!--          </div>-->
<!--        </el-popover>-->
<!--      </li>-->
      <li>
        <el-popover placement="left" popper-class="pop_wx" trigger="hover">
          <div class="cus-service">
            <img class="wx" src="@/assets/img/index/pic/code.jpg" />
<!--            <div class="addWx"></div>-->
          </div>
          <div slot="reference">
            <img class="cus-code" src="@/assets/img/index/icon/cus-code.svg" />
<!--            <div class="wx"></div>-->
            <div class="line">扫码关注</div>
          </div>
        </el-popover>
      </li>
      <li id="backup" @click="backup">
        <img class="top" src="@/assets/img/index/icon/right_navigation_4top.svg" />
        <div class="top-word">返回顶部</div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isLoad53kf: false
    }
  },
  created () {},
  mounted () {
    this.online()
  },
  methods: {
    //在线客服
    online() {
      // let href = 'https://p.qiao.baidu.com/cps/chat?siteId=17409992&userId=34503880&siteToken=dbadd38923e251ca2c0da0605366f46e'
      // let a = document.createElement('a')
      // a.setAttribute('href', href)
      // a.setAttribute('target', '_black')
      // document.body.appendChild(a);
      // a.click();
      if (/Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) return;
      if (this.isLoad53kf) return;

      const _53code = document.createElement("script");
      _53code.src = "https://tb.53kf.com/code/code/02b93c10327fa3450f166be56586f6619/1";
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(_53code, s);

      this.isLoad53kf = true;
    },
    backup() {
      document.querySelector("#app").scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block:    "start"  //
      });
    }
  }
}
// 回到顶部
</script>



// WEBPACK FOOTER //
// src/views/pc/components/custCare.vue